export default "__VITE_ASSET__BECM0VDm__"